import Base  from './base';
import Local from './local';
import REST  from './rest';

export default {
    Base,
    Local,
    REST
};
